import { supabase } from './supabase';

interface VerifyResult {
  isValid: boolean;
  coachId?: string;
  teamId?: string;
  autoAiAnalysis?: boolean;
}

export async function verifyAssessmentCode(code: string): Promise<VerifyResult> {
  try {
    const { data: assessmentCode, error } = await supabase
      .from('assessment_codes')
      .select('*')
      .eq('code', code)
      .maybeSingle();

    if (error || !assessmentCode) {
      return { isValid: false };
    }

    if (assessmentCode.expires_at && new Date(assessmentCode.expires_at) < new Date()) {
      return { isValid: false };
    }

    if (assessmentCode.team_id) {
      // Team code: reusable, check use_count vs max_uses
      const maxUses = assessmentCode.max_uses;
      const useCount = assessmentCode.use_count ?? 0;
      if (maxUses !== null && useCount >= maxUses) {
        return { isValid: false };
      }
    } else {
      // Individual code: single-use via is_used flag
      if (assessmentCode.is_used) {
        return { isValid: false };
      }
    }

    return {
      isValid: true,
      coachId: assessmentCode.coach_id || undefined,
      teamId: assessmentCode.team_id || undefined,
      autoAiAnalysis: assessmentCode.auto_ai_analysis || false,
    };
  } catch (error) {
    console.error('Error verifying assessment code:', error);
    return { isValid: false };
  }
}
